import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { useLang, api } from "../store";

const EMPTY = { name: "", email: "", company: "", date_from: "", date_to: "", notes: "" };

export const RequestForm = ({ subject, testid = "request-form" }) => {
  const { t } = useLang();
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/quote-requests", { ...form, subject, items: [] });
      toast.success(t("quote.success"));
      setForm(EMPTY);
    } catch {
      toast.error("Errore / Error");
    } finally {
      setSending(false);
    }
  };

  const input = "w-full rounded border border-white/10 bg-[#0a0b0e] px-4 py-3 text-sm outline-none transition-colors focus:border-amber-500";
  const label = "font-mono2 mb-1.5 block text-[10px] uppercase tracking-[0.25em] text-slate-500";

  return (
    <form onSubmit={submit} className="dc-card space-y-4 rounded p-7" data-testid={testid}>
      <p className="font-mono2 text-[11px] tracking-[0.3em] text-amber-500">{t("request.kicker")}</p>
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className={label}>{t("quote.name")}</label>
          <input required value={form.name} onChange={(e) => set("name", e.target.value)} className={input} data-testid={`${testid}-name`} />
        </div>
        <div>
          <label className={label}>{t("quote.email")}</label>
          <input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className={input} data-testid={`${testid}-email`} />
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        <div>
          <label className={label}>{t("quote.company")}</label>
          <input value={form.company} onChange={(e) => set("company", e.target.value)} className={input} data-testid={`${testid}-company`} />
        </div>
        <div>
          <label className={label}>{t("quote.from")}</label>
          <input type="date" value={form.date_from} onChange={(e) => set("date_from", e.target.value)} className={input} data-testid={`${testid}-date-from`} />
        </div>
        <div>
          <label className={label}>{t("quote.to")}</label>
          <input type="date" value={form.date_to} onChange={(e) => set("date_to", e.target.value)} className={input} data-testid={`${testid}-date-to`} />
        </div>
      </div>
      <div>
        <label className={label}>{t("request.detail")}</label>
        <textarea required rows={5} value={form.notes} onChange={(e) => set("notes", e.target.value)} placeholder={t("request.placeholder")} className={input} data-testid={`${testid}-notes`} />
      </div>
      <button disabled={sending} className="font-display flex w-full items-center justify-center gap-2 rounded bg-amber-600 py-3.5 text-sm uppercase tracking-[0.2em] text-black transition-colors hover:bg-amber-500 disabled:opacity-50" data-testid={`${testid}-submit`}>
        <Send size={15} /> {t("request.submit")}
      </button>
    </form>
  );
};
